<div class="instruction">{{ instruction.questionWording }}</div>
<ion-row class="ion-justify-content-center">
  <ion-button class="ok submitButton" color="secondary" (click)="ok.emit()"> OK </ion-button>
</ion-row>
